import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetJWTTokenService } from '../getJWTToken/get-jwttoken.service';
import { CryptoService } from '../crypto/crypto.service';
import { AlleCoreRest } from '../alle-core/alle-core-rest.service';
import { StoreServiceLibrary } from '../store/store.service';
import { GeneralUtilService } from '../general-util/generalUtil.service';
import { AlleCoreRestInterface } from '../alle-core/alle-core-rest.interface';
import { UniversalGetCountryRequest } from 'src/app/models/universal.model';
import { TranslateService } from '@ngx-translate/core';
import { keysUniversal } from 'src/app/resources/keys.resources';

@Injectable({
  providedIn: 'root'
})
export class UniversalService {

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private _cryptoService: CryptoService,
    private getJwtGeneral: GetJWTTokenService,
    private alleCoreRest: AlleCoreRest,
    private store: StoreServiceLibrary,
    private generalUtil: GeneralUtilService
  ) { }

  // getJwtUniversal(uri, un, pw, useJwtToken, fpUniversaljwt?) {
  //   if (useJwtToken) {
  //     return this.getJwtGeneral.getJwtGeneral(uri, un, pw, '', fpUniversaljwt);
  //   } else {
  //     return new Observable((observer) => {
  //       observer.next(null);
  //       observer.complete();
  //     });
  //   }
  // }

  getJwtUniversal(uri, un, pw, useJwtToken, fpUniversaljwt?, passReq?, passRes?) {
    if (useJwtToken) {
      return this.getJwtGeneral.getJwtGeneralCrypt(uri, un, pw, '', fpUniversaljwt, true, passReq, passRes);
    } else {
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
    }
  }

  getJwtProxy(useJwtToken, encrypted, url, un, pw, key, passReq, passRes): Observable<String> {
    if (useJwtToken) {
      if (encrypted) {
        return this.getJwtGeneral.getJwtGeneralCrypt(url, un, pw, '', url, true, passReq, passRes);
      } else {
        return this.getJwtGeneral.getJwtGeneral(url, un, pw, key);
      }
    } else {
      return new Observable<String>((observer) => {
        observer.next(null);
        observer.complete();
      });
    }
  }


  getCountries(url: string, uriJWT?, unJWT?, pwJWT?, useJwtToken?, fpjwt?, isoCountryP?, passReq?, passResp?) {
    const body = {
      getCountryByIsoRequest: {
        isoCountry: isoCountryP ? isoCountryP : '',
        language: this.translate.currentLang
      }
    };

    url = this.store.getJustOneUniversalPropertie('_URL_GET_COUNTRIES_LANDING_GENNIUS') || 'https://devuniversalws.allegra.tech/v1/getCountriesV2';
    let request: any = body;
    request['getCountryByIsoRequest']['security'] = this.generalUtil.getSecurityObject();

    let date = new Date().toLocaleString(atob('ZW4tVVM='), {
      timeZone: atob("QW1lcmljYS9Cb2dvdGE=")
    });
    let dateTmp = new Date(date);
    this.generalUtil.setLocalDate(dateTmp);

    let content = this._cryptoService.generateRequest(request, false, true, passReq);

    const encryptedRequest = {
      content
    }

    request = encryptedRequest;

    let objectRequest: AlleCoreRestInterface = {
      url: url,
      header: null,
      request: request,
      response: null,
      bearerToken: null,
      keyServicesSsl: null
    };

    return new Observable<any>((observer) => {
      date = new Date().toLocaleString(atob('ZW4tVVM='), {
        timeZone: atob("QXNpYS9EdWJhaQ==")
      });

      dateTmp = new Date(date);
      this.generalUtil.setLocalDate(dateTmp);
      this.getJwtUniversal(uriJWT, unJWT, pwJWT, useJwtToken, fpjwt, passReq, passResp).subscribe((jwtToken: string) => {
        objectRequest.bearerToken = jwtToken;
        this.alleCoreRest.callService(objectRequest).subscribe((resp) => {

          date = new Date().toLocaleString(atob('ZW4tVVM='), {
            timeZone: atob("QW1lcmljYS9Cb2dvdGE=")
          });

          dateTmp = new Date(date);
      
          this.generalUtil.setLocalDate(dateTmp);
          let respEncrypt = this._cryptoService.convertResponse(resp, false, true, passResp);
          try {
            resp = JSON.parse(respEncrypt);
          } catch (error) {
            resp = null;
          }

          date = new Date().toLocaleString(atob('ZW4tVVM='), {
            timeZone: atob("QXNpYS9EdWJhaQ==")
          });

          dateTmp = new Date(date);

          this.generalUtil.setLocalDate(dateTmp);
          observer.next(resp);
          observer.complete();
        }, (err) => {
          observer.error(err);
          observer.complete();
        })
      }, (err) => {
        observer.error(err);
        observer.complete();
      });
    });
  }

  // getCityByCountryId(countryId, url: string, uriJWT, unJWT, pwJWT, useJwtToken, fpjwt?, passReq?, passResp?) {
  //   const body: UniversalGetCityByCountryRequest = {
  //     getCityByCountryIdRequest: {
  //       id: countryId,
  //       language: this.translate.currentLang
  //     }
  //   };

  //   this.url = this.store.getJustOneUniversalPropertie(keysUniversal.UNIVERSAL_API_URL_GET_CITY_BY_COUNTRY_ID_V2);
  //   this.request = body;
  //   this.request['getCityByCountryIdRequest']['security'] = this.generalUtil.getSecurityObject();

  //   let content = this._cryptoService.generateRequest(this.request, false, true, passReq);

  //   const encryptedRequest: EncryptedRequest = {
  //     content
  //   }

  //   this.request = encryptedRequest;

  //   return new Observable<any>((observer) => {
  //     this.getJwtUniversal(uriJWT, unJWT, pwJWT, useJwtToken, fpjwt, passReq, passResp).subscribe((jwtToken: string) => {
  //       this.bearerToken = jwtToken;
  //       this.alleCoreRest.callService(this).subscribe((resp) => {
  //         let respEncrypt = this._cryptoService.convertResponse(resp, false, true, passResp);
  //         try {
  //           resp = JSON.parse(respEncrypt);
  //         } catch (error) {
  //           resp = null;
  //         }
  //         observer.next(resp);
  //         observer.complete();
  //       }, (err) => {
  //         observer.error(err);
  //         observer.complete();
  //       })
  //     }, (err) => {
  //       observer.error(err);
  //       observer.complete();
  //     });
  //   });
  // }

  // getAllPropertiesByApplicationId(url, user, pass, idApplication, fpUniversal?) {
  //   const sufix = 'v1/getallpropertiesbyapplicationid';


  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': 'Basic ' + btoa(user + ':' + pass)
  //   });

  //   const body: UniversalGetAllPropertiesByAplicationIdRequest = {
  //     getAllPropertiesByApplicationIdRequest: {
  //       idApplication: idApplication
  //     }
  //   };
  //   if (fpUniversal !== null && typeof fpUniversal !== 'undefined' && fpUniversal !== '') {
  //     this.alleCoreRest.sslCertificateCheckerURL(url + sufix, fpUniversal).subscribe((res) => {
  //       return this.
  //         http.post<UniversalGetAllPropertiesByAplicationIdResponse>(url + sufix, body, { headers });

  //     }, err => {
  //       return err;
  //     });
  //   } else {
  //     return this.
  //       http.post<UniversalGetAllPropertiesByAplicationIdResponse>(url + sufix, body, { headers });
  //   }
  // }

  // getAllPropertiesByApplicationidVS(url, idApplication) {
  //   const sufix = 'v1/getallpropertiesbyapplicationidVS';
  //   const body: UniversalGetAllPropertiesByAplicationIdRequest = {
  //     getAllPropertiesByApplicationIdRequest: {
  //       idApplication
  //     }
  //   };

  //   return this.http.post<UniversalGetAllPropertiesByApplicationidVSResponse>(url + sufix, body);
  // }

  getAllPropertiesByApplicationidVSDecrypt(url, idApplication, secretKey, uriJWT?, unJWT?, pwJWT?, useJwtToken?, fpUniversal?, fpUniversaljwt?, passReq?, passResp?): Observable<any> {
    let request: any = {
      getAllPropertiesByApplicationIdRequest: {
        idApplication
      }
    };
    let content = this._cryptoService.generateRequest(request, false, true, passReq);
    const encryptedRequest: any = {
      content
    }
    let objectRequest: AlleCoreRestInterface = {
      header: null,
      request: encryptedRequest,
      response: null,
      url,
      bearerToken: null
    };
    return new Observable<any>((observer) => {
      this.getJwtUniversal(uriJWT, unJWT, pwJWT, useJwtToken, fpUniversaljwt, passReq, passResp).subscribe((jwtToken: string) => {
        objectRequest.bearerToken = jwtToken;
        objectRequest.fpjwt = fpUniversal;
        this.alleCoreRest.callService(objectRequest).subscribe(
          (res: any) => {
            let respEncrypt = this._cryptoService.convertResponse(res, false, true, passResp);
            let strJSONPropertiesUniversal;
            try {
              res = JSON.parse(respEncrypt);
              let tempIv;

              if (res['iv']) {
                tempIv = res['iv'];
              } else if (res['IV']) {
                tempIv = res['IV'];
              }

              strJSONPropertiesUniversal = this._cryptoService.decryptedUniversal(res.content, secretKey, tempIv);
            } catch (error) {
              res = null;
            }
            observer.next(strJSONPropertiesUniversal);
          },
          (err) => {
            observer.error(err);
          },
          () => {
            observer.complete();
          }
        );
      }, (err) => {
        observer.error(err)
        observer.complete();
      });
    });
  }

  // getCurrency(iso?, uriJWT?, unJWT?, pwJWT?, useJwtToken?, fpjwt?, passReq?, passResp?) {
  //   this.url = this.store.getJustOneUniversalPropertie(keysUniversal.URL_GET_CURRENCY_V2);

  //   if (iso) {
  //     this.request = {
  //       iso: iso,
  //       language: this.translate.currentLang
  //     };
  //   } else {
  //     this.request = {
  //       language: this.translate.currentLang
  //     };
  //   }

  //   this.request['security'] = this.generalUtil.getSecurityObject();

  //   let content = this._cryptoService.generateRequest(this.request, false, true, passReq);

  //   const encryptedRequest: EncryptedRequest = {
  //     content
  //   }

  //   this.request = encryptedRequest;

  //   return new Observable<any>((observer) => {
  //     this.getJwtUniversal(uriJWT, unJWT, pwJWT, useJwtToken, fpjwt, passReq, passResp).subscribe((jwtToken: string) => {
  //       this.bearerToken = jwtToken;
  //       this.alleCoreRest.callService(this).subscribe((resp) => {
  //         let respEncrypt = this._cryptoService.convertResponse(resp, false, true, passResp);
  //         try {
  //           resp = JSON.parse(respEncrypt);
  //         } catch (error) {
  //           resp = null;
  //         }
  //         observer.next(resp);
  //         observer.complete();
  //       }, (err) => {
  //         observer.error(err);
  //         observer.complete();
  //       })
  //     }, (err) => {
  //       observer.error(err);
  //       observer.complete()
  //     });
  //   });
  // }

  getConfigGlobalUser(useJwt, isEncrypted, urlConfigUser, url, un, pw, fpjwt, reqPass, passResp) {
    return new Observable((observer) => {
      this.getJwtUniversal(url, un, pw, useJwt, fpjwt, reqPass, passResp).subscribe((jwtToken: string) => {
        let objectRequest: AlleCoreRestInterface = {
          header: null,
          response: null,
          url: urlConfigUser,
          bearerToken: null
        };

        if (isEncrypted) {
          objectRequest.bearerToken = jwtToken;
        } else {
          if (typeof jwtToken == 'string') {
            objectRequest.bearerToken = jwtToken;
          } else {
            objectRequest.bearerToken = jwtToken['token'];
          }
        }

        this.alleCoreRest.callServiceGet(objectRequest).subscribe((resp: any) => {
          let respEncrypt = resp;
          if (isEncrypted) {
            respEncrypt = this._cryptoService.convertResponse(resp, false, true, passResp);
          }
          try {
            if (isEncrypted) {
              resp = JSON.parse(respEncrypt);
            }
          } catch (error) {
            resp = null;
          }
          observer.next(resp);
          observer.complete();
        }, (err) => {
          observer.error(err);
          observer.complete();
        });
      }, (err) => {
        observer.error(err);
        observer.complete()
      });
    });
  }

}
